module.exports = __webpack_public_path__ + "media/images/recruit/top/mv_stone_blue-78dd51abd2d8267ca8d7aff1aab49d87.png";